"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./NonTimeBasedListEntries.scss");
var _NonTimeBasedListEntriesMethods = require("./NonTimeBasedListEntriesMethods");
var _generateFocusedImageAlt = _interopRequireDefault(require("../../utils/generateFocusedImageAlt"));
var _Pagination = _interopRequireDefault(require("../Pagination/Pagination"));
var _FocusedImage = _interopRequireDefault(require("../FocusedImage/FocusedImage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const NonTimeBasedListEntries = _ref => {
  let {
    variant,
    sidebarImage,
    entries,
    groupEntries,
    paddingClass,
    contentfulId
  } = _ref;
  const cards = entries;
  const groups = [];
  const maxEntriesPerPage = 20;
  const [pageLimit, setPageLimit] = (0, _react.useState)((0, _NonTimeBasedListEntriesMethods.CalculatePageLimit)(cards.length, maxEntriesPerPage));
  let isShort = false;

  // Determine the cards variant
  if (variant === "short-description") {
    isShort = true;
  }

  // If card grouping is enabled, group the cards
  if (groupEntries && cards?.length) {
    for (let i = 0; i < cards.length; i++) {
      const current = cards[i];
      let placed = false;
      if (!current?.groupingCategory) {
        cards[i].groupingCategory = "Other";
      }
      for (let j = 0; j < groups.length; j++) {
        if (groups?.[j]?.title === current.groupingCategory) {
          groups?.[j]?.entries?.push(current);
          placed = true;
          j = groups.length;
        }
      }
      if (!placed) {
        const groupHold = {
          title: current.groupingCategory,
          entries: [current]
        };
        groups.push(groupHold);
      }
    }
  }
  (0, _react.useEffect)(() => {
    setPageLimit((0, _NonTimeBasedListEntriesMethods.CalculatePageLimit)(cards.length, maxEntriesPerPage));
  }, [cards.length, maxEntriesPerPage]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `non-time-based-list-entries-container ${paddingClass && paddingClass}`,
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, isShort && sidebarImage?.focalPointImage && /*#__PURE__*/_react.default.createElement("div", {
    className: "sidebar-image-container",
    "data-sb-field-path": "sidebarImage"
  }, /*#__PURE__*/_react.default.createElement(_FocusedImage.default, {
    imageSizes: {
      mobile: {
        width: 320,
        height: 943,
        ratio: {
          width: 320,
          height: 943
        }
      },
      tablet: {
        width: 320,
        height: 943,
        ratio: {
          width: 320,
          height: 943
        }
      },
      desktop: {
        width: 320,
        height: 943,
        ratio: {
          width: 320,
          height: 943
        }
      }
    },
    focalPointImage: sidebarImage?.focalPointImage && sidebarImage?.focalPointImage,
    alt: (0, _generateFocusedImageAlt.default)(sidebarImage)
  })), isShort && groups?.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: "cards short-description"
  }, groups?.length > 1 ? groups.map((group, index) => /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: `${group}-${index}`
  }, /*#__PURE__*/_react.default.createElement(_NonTimeBasedListEntriesMethods.Group, {
    entries: group?.entries,
    title: group?.title
  }))) : /*#__PURE__*/_react.default.createElement(_NonTimeBasedListEntriesMethods.Group, {
    entries: groups[0]?.entries,
    title: groups[0]?.title
  })) : cards?.length && isShort && /*#__PURE__*/_react.default.createElement("div", {
    className: "cards short-description"
  }, /*#__PURE__*/_react.default.createElement(_Pagination.default, {
    data: cards,
    RenderComponent: "ShortDescriptionCard",
    pageLimit: pageLimit,
    dataLimit: maxEntriesPerPage
  })), !isShort && cards?.length && /*#__PURE__*/_react.default.createElement("div", {
    className: "cards long-description"
  }, cards && cards?.length > 1 ? /*#__PURE__*/_react.default.createElement(_Pagination.default, {
    data: cards,
    RenderComponent: "LongDescriptionCard",
    pageLimit: pageLimit,
    dataLimit: maxEntriesPerPage
  }) : /*#__PURE__*/_react.default.createElement(_NonTimeBasedListEntriesMethods.LongDescriptionCard, {
    eyebrow: cards?.[0]?.eyebrow,
    header: cards?.[0]?.header,
    subhead: cards?.[0]?.subhead,
    link: cards?.[0]?.link,
    ariaLabel: cards?.[0]?.customAriaLabel,
    image: cards?.[0]?.image,
    summary: cards?.[0]?.summary,
    contentfulId: cards?.[0].contentfulId
  })));
};
var _default = NonTimeBasedListEntries;
exports.default = _default;